function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useReducer } from "react";
import { useLocation } from "react-router-dom";
import CarrierLogisticsCommonsContext, { initialContextValue } from "./context/CarrierLogisticsCommonsContext";
import CarrierLogisticsCommonsDispatchContext from "./context/CarrierLogisticsCommonsDispatchContext";
import authorizationDispatch from "./dispatch/authorization/authorisationDispatch";
import localisationDispatch from "./dispatch/localisation/localisationDispatch";
import rootReducer from "./reducers";
export var CarrierLogisticsCommonsProvider = function(param) {
    var children = param.children, CLWSCaller = param.CLWSCaller, isPageAuthorized = param.isPageAuthorized;
    var pathname = useLocation().pathname;
    var ref = _slicedToArray(useReducer(rootReducer, initialContextValue), 2), state = ref[0], dispatch = ref[1];
    return /*#__PURE__*/ React.createElement(CarrierLogisticsCommonsContext.Provider, {
        value: state
    }, /*#__PURE__*/ React.createElement(CarrierLogisticsCommonsDispatchContext.Provider, {
        value: {
            localisationDispatch: localisationDispatch(dispatch)
        }
    }, children, /*#__PURE__*/ React.createElement(CLWSCaller, {
        isPageAuthorized: isPageAuthorized(pathname),
        authorizationDispatch: authorizationDispatch(dispatch)
    })));
};
export default CarrierLogisticsCommonsProvider;

//# sourceMappingURL=CarrierLogisticsCommonsProvider.js.map